import detect from '../detect/detect';

const gameInfo = detect.gamename();
const api = {
    local: 'http://opdev.api.lineage.plaync.com',
    rc: 'https://rc-apilineage.plaync.com',
    live: 'https://api-lineage.plaync.com'
};

const coupon = {
    local: 'http://lineagenshop.plaync.com/lineage/coupon/popup/couponProfileRegisterForm?gameCode=31',
    rc: 'http://rc.lineagenshop.plaync.com/lineage/coupon/popup/couponProfileRegisterForm?gameCode=31',
    live: 'http://lineagenshop.plaync.com/lineage/coupon/popup/couponProfileRegisterForm?gameCode=31'
};

const apiPath = api[detect.environment()];
const couponPath = coupon[detect.environment()];

class Cnb {
    constructor(options){
        let cnbConfig = {
            "type": "B",
            "bi": {
                "title": `${gameInfo.en}`,
                "url": "/",
                "image": {}
            },
            "header": {
                "large": "rgba(16,16,16,0.8)",
                "medium": "rgba(16,16,16,0.8)",
                "mediumSticky": "#5c443b",
                "lnb": "#c69c7c"
            },
            "useLeftMenu": true,
            "useJoinMenu": true,
            "joinURL": `http://search.plaync.com/${gameInfo.en}/index.jsp`,
            "useGameStart": "mobileGameDown",
            "gameStart": {
                "markUp": "<a href=\"#\" class=\"ncc-gamestart-btn__start\">다운로드</a>"
            },
            "mobileGameDown": {
                "showAndro": true,
                "showIos": true,
                "appName": "",
                "iosAppLink": "",
                "androAppLink": ""
            },
            "search": {
                "isShow": false,
                "destUrl": `http://search.plaync.com/${gameInfo.en}/index.jsp`,
                "site": `${gameInfo.en}`,
                "callback": "suggestKeyword",
                "collection": `${gameInfo.en}1query`,
                "display": 10,
                "pos": "lnb",
                "where": `${gameInfo.en}^tsearch`
            },
            "lnbData": [],
            "active": {
                "d1": 0,
                "d2": 0
            },
            "shortCut": {
                "enterCoupon": {
                    "url": couponPath
                }
            },
            "appDownloadData": {
                "isShow": false,
                "appList": []
            },
            "loginFN": "GNBLogin",
            "logoutFN": "GNBLogout",
            "useCharChangeMenu": false,
            "charChangeFN": "characterChange"
        };

        if(typeof options.image === 'object') {
            cnbConfig.bi.image = {
                "large": {
                    "path": options.image.large,
                    "style": {
                        "width": 102,
                        "height": 46,
                        "marginTop": 5
                    }
                },
                "medium": {
                    "path": options.image.medium,
                    "style": {
                        "width": 102,
                        "height": 46,
                        "marginTop": 5
                    }
                },
                "sticky": {
                    "path": options.image.mediumSticky,
                    "style": {
                        "width": 102,
                        "height": 46,
                        "marginTop": 5
                    }
                },
                "lnb": {
                    "path": options.image.lnb,
                    "style": {
                        "width": 102,
                        "height": 46,
                        "marginTop": 5
                    }
                }
            };
        } else {
            cnbConfig.bi.image = {
                "path": options.image,
                "style": {
                    "width": 102,
                    "height": 46,
                    "marginTop": 5
                }
            };
        }

        cnbConfig.header = options.color;

        $.ajax({
            url: `${apiPath}/api/main/cnb/userData`,
            xhrFields: {withCredentials: true}
        }).done(function(data){
            window.userData = data;
            window.userData.isLogin = data.login;
            window.cnb.start(cnbConfig);
        });
    }
}

export default Cnb;